import { Node } from 'tiptap'
import { toggleWrap, setBlockType, textblockTypeInputRule, toggleBlockType } from 'tiptap-commands'

export default class Iframe extends Node {

    get name() {
        return 'iframe'
    }

    get schema() {
        return {
            attrs: {
                src: {
                    default: null,
                },
            },
            group: 'block',
            selectable: false,
            parseDOM: [{
                tag: 'tiptap-2milion-iframe',
                getAttrs: dom => ({
                    src: dom.getAttribute('src'),
                }),
            }],
            toDOM: node => ['tiptap-2milion-iframe', {
                src: node.attrs.src,
                frameborder: 0,
                allowfullscreen: 'true',
            }],
        }
    }

    commands({ type }) {
        return attrs => (state, dispatch) => {
            const { selection } = state;
            const position = selection.$cursor
                ? selection.$cursor.pos
                : selection.$to.pos;
            const node = type.create(attrs);
            const transaction = state.tr.insert(position, node);
            dispatch(transaction);
        };
    }

    get view() {
        return {
            props: ['node', 'updateAttrs', 'view'],
            computed: {
                src: {
                    get() {
                        return this.node.attrs.src
                    },
                    set(src) {
                        this.updateAttrs({
                            src,
                        })
                    },
                },
            },
            template: `
                <div class="iframe">
                <iframe class="iframe__embed" :src="src"></iframe>
                <input
                    class="iframe__input"
                    type="text"
                    v-model="src"
                    v-if="view.editable"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
                </div>
                `,
        }
    }

}
